import React from 'react';

import { AnketaAlert } from 'shared/ui/AnketaAlert';

import { ImportantDataAlertTexts } from './ImportantDataAlert.texts';

export const ImportantDataAlert: FC = () => {
  return (
    <AnketaAlert
      color="green"
      variant="primary"
      subtitle={ImportantDataAlertTexts.subtitle}
    />
  );
};
